import React, {useState, useEffect} from 'react'
import clsx from 'clsx'
const Calendar = ({fechas, fechasEstadia}: any) => {
  const [daysByMonth, setDaysByMonth] = useState<any>([])
  const generateDaysInRange = (start: any, end: any) => {
    const startDay = new Date(start)
    const endDay = new Date(end)
    const months: any = {}

    while (startDay <= endDay) {
      const year = startDay.getFullYear()
      const month = startDay.toLocaleString('default', {month: 'long'})

      if (!months[month]) {
        months[month] = {
          name: `${month} ${year}`,
          days: [],
        }
      }
      console.log(startDay)
      months[month].days.push(new Date(startDay))
      startDay.setDate(startDay.getDate() + 1)
    }

    return Object.values(months)
  }
  useEffect(() => {
    if (fechas.desde && fechas.hasta) {
      setDaysByMonth(generateDaysInRange(fechas.desde, fechas.hasta))
    }
  }, [fechas])

  return (
    <div className='calendar-container'>
      <div className='calendar-line'>
        {daysByMonth.map((month: any, index: number) => {
          const filteredDays = month.days.filter((day: any) =>
            fechasEstadia.includes(day.getDate()),
          )
          return (
            <div key={index} className='month-block'>
              <div className='month-label'>
                {month.name} <span className='text-primary'>({filteredDays.length} días)</span>
              </div>
              <div className='days-container'>
                {month.days.map((date: any, idx: number) => (
                  <div
                    key={idx}
                    className={clsx('day', {isActive: fechasEstadia.includes(date.getDate())})}
                  >
                    <span className={'date'}>{date.getDate()}</span>
                  </div>
                ))}
              </div>
            </div>
          )
        })}
        <div className='d-flex justify-content-center align-items-end pb-3 fw-bold text-red'>
          <p className='mb-0 w-50px text-primary'>{fechasEstadia.length} días</p>
        </div>
      </div>
    </div>
  )
}

export default Calendar
